import { TextField as MUITextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  useAddress
} from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function DetailApplicantOverseas({ formik, colSpan = 6 }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);
  const typeOfbusinessindustryConfig = get(
    masterData,
    "typeOfbusinessindustryConfig",
    []
  );
  const jobTable = get(formik.values, `document.JobPositionWorkOverseas.0`, {});
  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  const index = 0;
  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);

  const isYearMonth =
    formik.values?.document.ContractTermTypeWorkOverseas === "Y";
  const isPeriod = formik.values?.document.ContractTermTypeWorkOverseas === "P";
  const isOther = formik.values?.document.ContractTermTypeWorkOverseas === "O";

  useEffect(() => {
    let sum = 0;
    console.log(formik.values.document.PrivateCompanyTotalLast3Year);
    console.log(formik.values.document.PrivateCompanyTotalLast2Year);
    console.log(formik.values.document.PrivateCompanyTotalLastYear);
    if (
      formik.values.document.PrivateCompanyTotalLast3Year !== 0 &&
      formik.values.document.PrivateCompanyTotalLast2Year !== 0 &&
      formik.values.document.PrivateCompanyTotalLastYear !== 0
    ) {
      sum =
        parseFloat(formik.values.document.PrivateCompanyTotalLast3Year) +
        parseFloat(formik.values.document.PrivateCompanyTotalLast2Year) +
        parseFloat(formik.values.document.PrivateCompanyTotalLastYear);

      formik.setFieldValue("document.GrandTotal", sum);
    }
  }, [
    formik.values.document.PrivateCompanyTotalLast3Year,
    formik.values.document.PrivateCompanyTotalLast2Year,
    formik.values.document.PrivateCompanyTotalLastYear,
  ]);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job position"
                  name={`document.JobPositionWorkOverseas.${index}.jobID`}
                  defaultValue=""
                  // value={get(
                  //   formik.values,
                  //   `document.JobTable.${index}.jobID`,
                  //   ""
                  // )}
                  value={
                    formik.values.document.JobPositionWorkOverseas[0].jobID
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>

                <Select
                  disabled={!canEdit}
                  label="Select Job Sub position"
                  name={`document.JobPositionWorkOverseas.${index}.jobsubID`}
                  value={
                    formik.values.document.JobPositionWorkOverseas[0].jobsubID
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ width: 90 }}>Job Title</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkOverseas.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkOverseas.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.JobPositionWorkOverseas.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkOverseas.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Job description</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkOverseas.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkOverseas.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `document.JobPositionWorkOverseas.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkOverseas.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel> Contract term</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Year"
                      checked={isYearMonth}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkOverseas",
                          "Y"
                        )
                      }
                    />
                  }
                  label="Year - Months"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Period (dd-mm-yyyy to dd-mm-yyyy)"
                      checked={isPeriod}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkOverseas",
                          "P"
                        )
                      }
                    />
                  }
                  label="Period"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="Other"
                      checked={isOther}
                      onChange={() =>
                        formik.setFieldValue(
                          "document.ContractTermTypeWorkOverseas",
                          "O"
                        )
                      }
                    />
                  }
                  label="Other ( Please specify )"
                />
              </FormGroup>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                {isYearMonth && (
                  <>
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Year"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractYearWorkOverseas"
                      value={formik.values?.document.ContractYearWorkOverseas}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        "document.ContractYearWorkOverseas",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractYearWorkOverseas",
                        formik
                      )}
                    />
                    <TextField
                      disabled={!canEdit}
                      className={classes.formControl}
                      variant="outlined"
                      placeholder="Month"
                      // type="number"
                      onKeyDown={(e) => {
                        const pattern = /[^0-9]/g;
                        const isNotAllow =
                          e.key.length === 1 && pattern.test(e.key);

                        if (isNotAllow) {
                          e.preventDefault();
                        }
                      }}
                      name="document.ContractMonthsWorkOverseas"
                      value={formik.values?.document.ContractMonthsWorkOverseas}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        "document.ContractMonthsWorkOverseas",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractMonthsWorkOverseas",
                        formik
                      )}
                    />
                  </>
                )}
                {isPeriod && (
                  <>
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodFromWorkOverseas"
                      maxDate={
                        formik.values?.document.ContractPeriodFromWorkOverseas
                          ? formik.values?.document
                            .ContractPeriodFromWorkOverseas
                          : undefined
                      }
                      value={
                        formik.values?.document
                          .ContractPeriodFromWorkOverseas || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodFromWorkOverseas",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        "document.ContractPeriodFromWorkOverseas",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractPeriodFromWorkOverseas",
                        formik
                      )}
                    />
                    <DatePicker
                      disabled={!canEdit}
                      className={classes.formControl}
                      inputVariant="outlined"
                      // disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End date"
                      views={["year", "month", "date"]}
                      name="document.ContractPeriodToWorkOverseas"
                      minDate={
                        formik.values?.document.ContractPeriodToWorkOverseas
                          ? formik.values?.document.ContractPeriodToWorkOverseas
                          : undefined
                      }
                      value={
                        formik.values?.document.ContractPeriodToWorkOverseas ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          "document.ContractPeriodToWorkOverseas",
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        "document.ContractPeriodToWorkOverseas",
                        formik
                      )}
                      helperText={getErrorMessage(
                        "document.ContractPeriodToWorkOverseas",
                        formik
                      )}
                    />
                  </>
                )}
                {isOther && (
                  <TextField
                    disabled={!canEdit}
                    className={classes.formControl}
                    variant="outlined"
                    placeholder="Please specify"
                    name="document.ContractOtherWorkOverseas"
                    value={formik.values?.document.ContractOtherWorkOverseas}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(
                      "document.ContractOtherWorkOverseas",
                      formik
                    )}
                    helperText={getErrorMessage(
                      "document.ContractOtherWorkOverseas",
                      formik
                    )}
                  />
                )}
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Company Name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasCompanyName"
                value={formik.values.document.WorkOverseasCompanyName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WorkOverseasCompanyName", formik)}
                helperText={getErrorMessage(
                  "document.WorkOverseasCompanyName",
                  formik
                )}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Registration number </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasRegistrationNumber"
                value={formik.values.document.WorkOverseasRegistrationNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  "document.WorkOverseasRegistrationNumber",
                  formik
                )}
                helperText={getErrorMessage(
                  "document.WorkOverseasRegistrationNumber",
                  formik
                )}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel> Address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasCompanyAddress"
                value={formik.values.document.WorkOverseasCompanyAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WorkOverseasCompanyAddress", formik)}
                helperText={getErrorMessage(
                  "document.WorkOverseasCompanyAddress",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Office number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasOfficePhoneNumber"
                value={formik.values.document.WorkOverseasOfficePhoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  "document.WorkOverseasOfficePhoneNumber",
                  formik
                )}
                helperText={getErrorMessage(
                  "document.WorkOverseasOfficePhoneNumber",
                  formik
                )}
              />
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Company website/e-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasCompanyEmail"
                value={formik.values.document.WorkOverseasCompanyEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WorkOverseasCompanyEmail", formik)}
                helperText={getErrorMessage(
                  "document.WorkOverseasCompanyEmail",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Business/products or services description</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WorkOverseasProductsServices"
                value={formik.values.document.WorkOverseasProductsServices}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WorkOverseasProductsServices", formik)}
                helperText={getErrorMessage(
                  "document.WorkOverseasProductsServices",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Type of business industry</InputLabel>

              <Select
                variant="outlined"
                style={{ marginLeft: "10px", width: 150 }}
                name="document.typeOfbusinessindustryID"
                value={formik.values.document.typeOfbusinessindustryID}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                {typeOfbusinessindustryConfig.map((x) => (
                  <MenuItem
                    key={x.typeOfbusinessindustryID}
                    value={x.typeOfbusinessindustryID}
                  >
                    {x.typeOfbusinessindustryName}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="personal.gender"
                    value="M"
                    checked={formik.values.document.PublicCompany === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PublicCompany",
                        formik.values.document.PublicCompany === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label=" A public company listed on a stock exchange"
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Country of the listed company </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.ListedCompany"
                value={formik.values.document.ListedCompany}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.ListedCompany", formik)}
                helperText={getErrorMessage("document.ListedCompany", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Stock symbol </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.StockSymbol"
                value={formik.values.document.StockSymbol}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.StockSymbol", formik)}
                helperText={getErrorMessage("document.StockSymbol", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Name of stock exchange</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.NameStock"
                value={formik.values.document.NameStock}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.NameStock", formik)}
                helperText={getErrorMessage("document.NameStock", formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PrivateCompany"
                    checked={formik.values.document.PrivateCompany === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PrivateCompany",
                        formik.values.document.PrivateCompany === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label=" A private company that has been in operation no less than 3
              years with combined revenue of no less than 150 million USD in
              the last 3 years"
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Year </InputLabel>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Total revenue (USD)</InputLabel>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last year </InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="End of Accounting Period"
                views={["year", "month", "date"]}
                disabled={!canEdit}
                name="document.PrivateCompanyLastYear"
                value={formik.values.document.PrivateCompanyLastYear}
                onChange={(date) => {
                  formik.setFieldValue(`document.PrivateCompanyLastYear`, date.format("YYYY-MM-DD"));
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyLastYear", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyLastYear",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PrivateCompanyTotalLastYear"
                value={formik.values.document.PrivateCompanyTotalLastYear}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyTotalLastYear", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyTotalLastYear",
                  formik
                )}
                type="number"
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last 2nd year </InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="End of Accounting Period"
                views={["year", "month", "date"]}
                disabled={!canEdit}
                name="document.PrivateCompanyLast2Year"
                value={formik.values.document.PrivateCompanyLast2Year}
                onChange={(date) => {
                  formik.setFieldValue(`document.PrivateCompanyLast2Year`, date.format("YYYY-MM-DD"));
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyLast2Year", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyLast2Year",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PrivateCompanyTotalLast2Year"
                value={formik.values.document.PrivateCompanyTotalLast2Year}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyTotalLast2Year", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyTotalLast2Year",
                  formik
                )}
                type="number"
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last 3rd year</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="End of Accounting Period"
                views={["year", "month", "date"]}
                disabled={!canEdit}
                name="document.PrivateCompanyLast3Year"
                value={formik.values.document.PrivateCompanyLast3Year}
                onChange={(date) => {
                  formik.setFieldValue(`document.PrivateCompanyLast3Year`, date.format("YYYY-MM-DD"));
                }}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyLast3Year", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyLast3Year",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.PrivateCompanyTotalLast3Year"
                value={formik.values.document.PrivateCompanyTotalLast3Year}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.PrivateCompanyTotalLast3Year", formik)}
                helperText={getErrorMessage(
                  "document.PrivateCompanyTotalLast3Year",
                  formik
                )}
                disabled={!canEdit}
                type="number"
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Grand total</InputLabel>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="document.GrandTotal"
                value={formik.values.document.GrandTotal}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.GrandTotal", formik)}
                helperText={getErrorMessage("document.GrandTotal", formik)}
                disabled={!canEdit}
                inputProps={{ readOnly: true }}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
